<template>
  <WCForm
    :form="$v.form"
    @submit.prevent="$emit('continue')"
    @update:value="$emit('form-changed', form)"
    @update:valid="$emit('update:valid', $event)"
  >
    <PlatformRenderer>
      <template v-slot:onMobile>
        <section>
          <WCFormGroup :field="$v.form.firstName">
            <WCLabel for="identity-form__firstName">{{ $t('firstName') }}</WCLabel>
            <WCInput
              class="bg-light mb-1"
              id="identity-form__firstName"
              autocomplete="given-name"
            />
            <WCValidationErrors />
          </WCFormGroup>

          <WCFormGroup :field="$v.form.lastName">
            <WCLabel for="identity-form__lastName">{{ $t('lastName') }}</WCLabel>
            <WCInput class="bg-light" id="identity-form__lastName" autocomplete="family-name" />
            <WCValidationErrors />
          </WCFormGroup>

          <WCFormGroup :field="$v.form.email">
            <WCLabel for="identity-form__email">{{ $t('emailAddress') }}</WCLabel>
            <WCInput class="bg-light" id="identity-form__email" autocomplete="email" />
            <WCValidationErrors />
          </WCFormGroup>

          <WCFormGroup :field="$v.form.phone">
            <WCLabel for="identity-form__phone">{{ $t('phoneNumber') }}</WCLabel>
            <WCInput
              autocomplete="tel"
              class="bg-light"
              id="identity-form__phone"
              @input="changePhoneNumberFormat(form.phone)"
            />
            <WCValidationErrors />
          </WCFormGroup>
        </section>
      </template>
      <template v-slot:onDesktop>
        <section>
          <div class="d-flex justify-content-between">
            <WCFormGroup class="wc-input" :field="$v.form.firstName">
              <WCLabel for="identity-form__firstName">{{ $t('firstName') }}</WCLabel>
              <WCInput
                class="bg-light form-input"
                id="identity-form__firstName"
                autocomplete="given-name"
              />
              <WCValidationErrors />
            </WCFormGroup>

            <WCFormGroup class="wc-input" :field="$v.form.lastName">
              <WCLabel for="identity-form__lastName">{{ $t('lastName') }}</WCLabel>
              <WCInput
                class="bg-light form-input"
                id="identity-form__lastName"
                autocomplete="family-name"
              />
              <WCValidationErrors />
            </WCFormGroup>
          </div>

          <div class="d-flex justify-content-between">
            <WCFormGroup class="wc-input" :field="$v.form.email">
              <WCLabel for="identity-form__email">{{ $t('emailAddress') }}</WCLabel>
              <WCInput class="bg-light form-input" id="identity-form__email" autocomplete="email" />
              <WCValidationErrors />
            </WCFormGroup>

            <WCFormGroup class="wc-input" :field="$v.form.phone">
              <WCLabel for="identity-form__phone">{{ $t('phoneNumber') }}</WCLabel>
              <WCInput
                autocomplete="tel"
                class="bg-light form-input"
                id="identity-form__phone"
                @input="changePhoneNumberFormat(form.phone)"
              />
              <WCValidationErrors />
            </WCFormGroup>
          </div>
        </section>
      </template>
    </PlatformRenderer>
    <div class="d-flex justify-content-between mt-3 mb-2">
      <button
        id="identity-form_goback-button"
        class="btn btn-primary btn-block w-25 stage-button"
        @click.prevent="onClickGoBack"
      >
        {{ $t('goBack') }}
      </button>
      <button
        id="identity-form_continue-button"
        class="btn btn-primary btn-block w-25 m-0 stage-button"
        :disabled="$v.form.$invalid"
      >
        {{ $t('continue') }}
      </button>
    </div>
  </WCForm>
</template>

<script>
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { phone } from '@/utils/validators/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import WCForm from '@/modules/forms/components/WCForm/WCForm.vue';
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import PhoneNumberFormatMixin from '@/mixins/PhoneNumberFormatMixin';

export default {
  props: {
    billing: {
      type: Object,
    },
  },
  components: {
    WCFormGroup,
    WCInput,
    WCValidationErrors,
    WCForm,
    WCLabel,
    PlatformRenderer,
  },
  mixins: [PhoneNumberFormatMixin],
  created() {
    this.$emit('update:valid', !this.$v.form.$invalid);
  },
  data() {
    return {
      form: {
        firstName: this.billing.firstName || '',
        lastName: this.billing.lastName || '',
        email: this.billing.email || '',
        phone: this.billing.phone ? this.formatPhoneNumber(this.billing.phone) : '',
      },
    };
  },
  validations: {
    form: {
      firstName: {
        required,
        maxLength: maxLength(25),
      },
      lastName: {
        required,
        maxLength: maxLength(25),
      },
      email: {
        required,
        email,
        maxLength: maxLength(50),
      },
      phone: {
        required,
        phone,
      },
    },
  },
  methods: {
    onClickGoBack() {
      this.$emit('goback');
    },
    onClickContinue() {
      this.$emit('continue');
    },
    /**
     * Method to format the phone number
     * Uses PhoneNumberFormatMixin
     */
    changePhoneNumberFormat(phoneNumber) {
      this.form.phone = this.formatPhoneNumber(phoneNumber);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-input {
  width: 45%;
}
.form-input {
  margin-bottom: $margin-1;
}
.stage-button {
  min-width: 33%;
}
</style>
